import React from 'react';

import { ButtonContainer } from './styles';

export default function PersonalOutlineButton({
  message,
  color = false,
  Icon,
  disabled = false,
  fontColor = null,
  borderColor = null,
  ...rest
}) {
  return (
    <ButtonContainer
      type="button"
      color={color}
      borderColor={borderColor}
      disabled={disabled}
      fontColor={fontColor}
      {...rest}
    >
      <span>
        {Icon && <Icon size={14} />} {message}
      </span>
    </ButtonContainer>
  );
}
